import lerp from "./lerp";

export default function rand(low, high) {
	return Math.round(lerp(low, high, Math.random()));
}
